// extracted by mini-css-extract-plugin
export var section = "page-title-columns-module--section--Uk5qZ";
export var column = "page-title-columns-module--column--jRij6";
export var arrowDesktop = "page-title-columns-module--arrowDesktop--vfNay";
export var arrowMobile = "page-title-columns-module--arrowMobile--1Vuaz";